import { Observable } from 'rxjs'
import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { CustomCodeView } from '@tv3/store/custom-codes/custom-code.model'
import { selectAllCustomCodeViews } from '@tv3/store/custom-codes/custom-code.selectors'
import { ModifyCustomCodeDialogService } from '@tv3/containers/rentals/custom-codes/dialogs/modify/modify-custom-code-dialog.service'
import { DataTokenDef, SignatureDataDictHelperService } from '@tv3/services/signature-data-dict-helper.service'
import { DragDropManagerService } from '@tokeet-frontend/signature'
import { DataCheckerService } from '@tokeet-frontend/tv3-platform'
import { CustomCodeGuard } from '@tv3/guards/custom-code.guard'

@Component({
  selector: 'app-mini-custom-codes',
  templateUrl: './mini-custom-codes.component.html',
  styleUrls: ['./mini-custom-codes.component.scss'],
})
export class MiniCustomCodesComponent implements OnInit, AfterViewChecked {
  @ViewChild('codeDraggableTokenList') codeDraggableTokenList: ElementRef

  @Input() selectedField: HTMLElement
  @Output() select = new EventEmitter<HTMLElement>()

  items$: Observable<CustomCodeView[]> = this.store.pipe(select(selectAllCustomCodeViews))

  constructor(
    private store: Store<any>,
    private customCodeDrawer: ModifyCustomCodeDialogService,
    private dataCheckerService: DataCheckerService,
    public dataDicHelper: SignatureDataDictHelperService,
    public signFieldManager: DragDropManagerService
  ) {
    this.dataCheckerService.check([CustomCodeGuard])
  }

  ngOnInit(): void {}

  ngAfterViewChecked() {
    this.signFieldManager.addDraggableContainer(this.codeDraggableTokenList)
  }

  getDataTokenDef(helper: SignatureDataDictHelperService, codeDataItem: CustomCodeView): DataTokenDef {
    return helper.getCustomCodeDataTokenDef(codeDataItem)
  }

  onEdit(item: CustomCodeView) {
    this.customCodeDrawer.open(item)
  }

  onAdd() {
    this.customCodeDrawer.open()
  }
}
